export enum FeatureFlag {
  GROWTH_WEBSITE_BANNER = "GROWTH_WEBSITE_BANNER",
}
